<loading-indicator *ngIf="!formReady"></loading-indicator>
<div [formGroup]="formData" class="form-host" *ngIf="formReady">
  <div class="portfoliosSearchFormContainer">
    <div class="searchFormContainerLeft">
      <table aria-hidden="true">
        <tbody>
          <tr>
            <td class="LabelContainer dialogTableCellPaddingTop">
              <span class="dialogLabel uppercase">{{ 'valuationPortfolio.valuationPortfolioName' | translate }}</span>
            </td>
          </tr>
          <tr>
            <td class="FieldContainer">
              <input type="text" formControlName="valuationPortfolioName" />
            </td>
          </tr>
          <tr>
            <td class="LabelContainer dialogTableCellPaddingTop">
              <span class="dialogLabel uppercase">{{ 'valuationPortfolio.valuationPortfolioOid' | translate }}</span>
            </td>
          </tr>
          <tr>
            <td class="FieldContainer">
              <kendo-numerictextbox style="width: 100%;" formControlName="valuationPortfolioOid" format="#" [spinners]="false"></kendo-numerictextbox>
            </td>
          </tr>
          <tr>
            <td class="LabelContainer dialogTableCellPaddingTop">
              <span class="dialogLabel uppercase">{{ 'valuationPortfolio.puid' | translate }}</span>
            </td>
          </tr>
          <tr>
            <td class="FieldContainer">
              <span *ngIf="selectedItemType === 'projectstd' && initiallySelectedItemType === 'projectstd'" class="dialogLabel">{{selectedItem.Oid}}, {{selectedItem.Name}}</span>
              <span *ngIf="selectedItemType !== 'projectstd' && initiallySelectedItemType === 'projectstd'" class="dialogLabel">{{initiallySelectedItem.Oid}}, {{initiallySelectedItem.Name}}</span>
              <input *ngIf="selectedItemType !== 'projectstd' && initiallySelectedItemType !== 'projectstd'" type="text" formControlName="projectId" />
            </td>
          </tr>
          <tr>
            <td class="LabelContainer dialogTableCellPaddingTop">
              <span class="dialogLabel uppercase">{{ 'valuationPortfolio.valuationDueDate' | translate }}</span>
            </td>
          </tr>
          <tr>
            <td class="FieldContainer angularForm">
              <kendo-datepicker class="datepicker-search-form" formControlName="valuationDate" >
              </kendo-datepicker>
            </td>
          </tr>
          <tr>
            <td class="LabelContainer dialogTableCellPaddingTop">
              <span class="dialogLabel uppercase">{{ 'valuationPortfolio.client' | translate }}</span>
            </td>
          </tr>
          <tr>
            <td class="FieldContainer">
              <input type="text" formControlName="clientIdDescription" />
            </td>
          </tr>
          <tr>
            <td class="LabelContainer dialogTableCellPaddingTop">
              <span class="dialogLabel uppercase">{{ 'projectValuation.valuationStatus' | translate }}</span>
            </td>
          </tr>
          <tr>
            <td class="FieldContainer">
              <kendo-dropdownlist formControlName="valuationStatusId"
                                  [data]="reflistData.ref_portfolio_valuation_status"
                                  [defaultItem]="{ text: 'Select valuation status', value: null }"
                                  textField="description"
                                  valueField="oid"
                                  [valuePrimitive]="true">
              </kendo-dropdownlist>
            </td>
          </tr>
          <tr>
            <td class="LabelContainer dialogTableCellPaddingTop">
              <span class="dialogLabel uppercase">{{ 'valuationPortfolio.recordStatusId' | translate }}</span>
            </td>
          </tr>
          <tr>
            <td class="FieldContainer">
              <kendo-dropdownlist formControlName="recordStatus"
                                  [data]="reflistData.ref_recordstatus"
                                  [defaultItem]="{ text: 'Select record status', value: null }"
                                  textField="description"
                                  valueField="oid"
                                  [valuePrimitive]="true">
              </kendo-dropdownlist>
            </td>
          </tr>
          <tr>
            <td class="LabelContainer dialogTableCellPaddingTop">
              <span class="dialogLabel uppercase">{{ 'valuationPortfolio.projectLeader' | translate }}</span>
            </td>
          </tr>
          <tr>
            <td class="FieldContainer">
              <kendo-dropdownlist formControlName="projectLeader"
                                  [data]="user"
                                  [defaultItem]="{ text: 'Select project leader', value: null }"
                                  textField="description"
                                  valueField="oid"
                                  [valuePrimitive]="true">
              </kendo-dropdownlist>
            </td>
          </tr>
          <tr>
            <td class="LabelContainer dialogTableCellPaddingTop">
              <span class="dialogLabel uppercase">{{ 'valuationPortfolio.projectTeam' | translate }}</span>
            </td>
          </tr>
          <tr>
            <td class="FieldContainer">
              <kendo-dropdownlist formControlName="teamMember"
                                  [data]="user"
                                  [defaultItem]="{ text: 'Select team member', value: null }"
                                  textField="description"
                                  valueField="oid"
                                  [valuePrimitive]="true">
              </kendo-dropdownlist>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
